import React from 'react';

class Symbols extends React.Component{ 
    constructor(props){
        super(props);

        this.symbols = [
            ["HALFWIDTH KATAKANA MIDDLE DOT", "･"],
            ["LEFT-POINTING DOUBLE ANGLE QUOTATION MARK", "«"],
            ["RIGHT-POINTING DOUBLE ANGLE QUOTATION MARK", "»"],
            ["LEFT BLACK LENTICULAR BRACKET", "【"],
            ["RIGHT BLACK LENTICULAR BRACKET", "】"],
            ["LEFT TORTOISE SHELL BRACKET","〔"],
            ["RIGHT TORTOISE SHELL BRACKET","〕"],
            ["HORIZONTAL ELLIPSIS", "…"],
            ["EM DASH", "—"],
            ["IDEOGRAPHIC COMMA", "、"],
            ["KATAKANA-HIRAGANA PROLONGED SOUND MARK", "ー"],
            ["IDEOGRAPHIC ITERATION MARK", "々"],
            ["HIRAGANA ITERATION MARK", "ゝ"],
            ["HIRAGANA VOICED ITERATION MARK", "ゞ"],
            ["COMBINING ACUTE ACCENT", "́"],
            ["COMBINING BREVE", "̆"],
            ["COMBINING MACRON", "̄"],
            ["COMBINING CANDRABINDU", "̐"],
            ["CYRILLIC SMALL LETTER SHORT U", "ў"],
            ["HIRAGANA LETTER SMALL TU", "っ"],
            ["HIRAGANA LETTER SMALL YA", "ゃ"],
            ["HIRAGANA LETTER SMALL YU", "ゅ"],
            ["HIRAGANA LETTER SMALL YO", "ょ"],
            ["CIRCLED DIGIT ONE", "①"],
            ["CIRCLED DIGIT TWO", "②"],
            ["CIRCLED DIGIT THREE", "③"],
            ["CIRCLED DIGIT FOUR", "④"],
            ["CIRCLED DIGIT FIVE", "⑤"],
            ["CIRCLED DIGIT SIX", "⑥"],
            ["CIRCLED DIGIT SEVEN", "⑦"],
            ["CIRCLED DIGIT EIGHT", "⑧"],
            ["CIRCLED DIGIT NINE", "⑨"],
            ["CIRCLED NUMBER TEN", "⑩"],
            ["CIRCLED NUMBER ELEVEN", "⑪"],
            ["CIRCLED NUMBER TWELVE", "⑫"],
            ["CIRCLED NUMBER THIRTEEN", "⑬"],
            ["CIRCLED NUMBER FOURTEEN", "⑭"],
            ["CIRCLED NUMBER FIFTEEN", "⑮"],
            ["CIRCLED NUMBER SIXTEEN", "⑯"],
            ["CIRCLED NUMBER SEVENTEEN", "⑰"],
            ["CIRCLED NUMBER EIGHTEEN", "⑱"],
            ["CIRCLED NUMBER NINETEEN", "⑲"],
            ["CIRCLED NUMBER TWENTY", "⑳"],
            ["KATAKANA MIDDLE DOT", "・"],
            ["BULLET", "•"],
            ["WHITE DIAMOND", "◇"],
            ["REFERENCE MARK", "※"],
            
            ["LATIN SMALL LETTER D WITH DOT BELOW", "ḍ"],
            ["LATIN SMALL LETTER H WITH DOT BELOW", "ḥ"],
            ["LATIN SMALL LETTER L WITH DOT BELOW", "ḷ"],
            ["LATIN SMALL LETTER M WITH DOT BELOW", "ṃ"],
            ["LATIN SMALL LETTER N WITH DOT BELOW", "ṇ"],
            ["LATIN SMALL LETTER R WITH DOT BELOW", "ṛ"],
            ["LATIN SMALL LETTER S WITH DOT BELOW", "ṣ"],
            ["LATIN SMALL LETTER T WITH DOT BELOW", "ṭ"],
            
            ["LATIN SMALL LETTER A WITH MACRON", "ā"],
            ["LATIN SMALL LETTER I WITH MACRON", "ī"],
            ["LATIN SMALL LETTER U WITH MACRON", "ū"],
            ["LATIN SMALL LETTER E WITH MACRON", "ē"],
            ["LATIN SMALL LETTER O WITH MACRON", "ō"],

            ["LATIN SMALL LETTER A WITH GRAVE", "à"],
            ["LATIN SMALL LETTER E WITH GRAVE", "è"],
            ["LATIN SMALL LETTER U WITH GRAVE", "ù"],

            ["LATIN SMALL LETTER A WITH ACUTE", "á"],
            ["LATIN SMALL LETTER E WITH ACUTE", "é"],
            ["LATIN SMALL LETTER I WITH ACUTE", "í"],
            ["LATIN SMALL LETTER O WITH ACUTE", "ó"],
            ["LATIN SMALL LETTER U WITH ACUTE", "ú"],
            ["LATIN SMALL LETTER S WITH ACUTE", "ś"],
            
            ["LATIN SMALL LETTER A WITH CIRCUMFLEX", "â"],
            ["LATIN SMALL LETTER E WITH CIRCUMFLEX", "ê"],
            ["LATIN SMALL LETTER I WITH CIRCUMFLEX", "î"],
            ["LATIN SMALL LETTER O WITH CIRCUMFLEX", "ô"],
            ["LATIN SMALL LETTER U WITH CIRCUMFLEX", "û"],

            ["LATIN SMALL LETTER A WITH DIAERESIS", "ä"],
            ["LATIN SMALL LETTER E WITH DIAERESIS", "ë"],
            ["LATIN SMALL LETTER I WITH DIAERESIS", "ï"],
            ["LATIN SMALL LETTER O WITH DIAERESIS", "ö"],
            ["LATIN SMALL LETTER U WITH DIAERESIS", "ü"],
            ["LATIN SMALL LETTER Y WITH DIAERESIS", "ÿ"],

            ["LATIN SMALL LETTER R WITH DOT BELOW AND MACRON", "ṝ"],
            ["LATIN SMALL LETTER L WITH DOT BELOW AND MACRON", "ḹ"],
            
            ["LATIN SMALL LETTER C WITH CEDILLA", "ç"],
            ["LATIN SMALL LETTER N WITH DOT ABOVE", "ṅ"],
            ["LATIN SMALL LETTER N WITH TILDE", "ñ"],

            ["LATIN SMALL LIGATURE OE", "œ"],
            ["LATIN SMALL LETTER AE", "æ"],

            ["INVERTED EXCLAMATION MARK", "¡"],
            ["INVERTED QUESTION MARK", "¿"],
            ["LATIN SMALL LETTER SHARP S", "ß"]
        ];

        this.onClick = this.onClick.bind(this);
    }

    onClick(c){
        this.props.onClick(c)
    }

    render(){
        return (
            <div className="popover bs-popover-bottom shadow">
                <div className="arrow"></div>
                <div className="popover-body">
                    <div className="symbols d-flex flex-wrap mt-3">
                        {this.symbols.map(symbol => (
                            <button 
                                key={symbol[0]}
                                className="btn btn-outline-secondary btn-icon btn-sm" 
                                onMouseDown={()=>this.onClick(symbol[1])} 
                                title={symbol[0]}
                            >
                                {symbol[1]}
                            </button>
                        ))}
                    </div>    
                    <span className="fa fa-times close" onClick={this.props.onClose}></span>        
                </div>
            </div>
        )
    }

}

export default Symbols;